import { type AuditActionType } from '@exam-management/graphql';
import { EllipsisText, type GridColDef, Text } from '@shared/components';
import { formatDateTime, getAuditActionTypeText } from '@shared/utils';

export interface QBSActivityLogListItem {
  actionTime: Date;
  action: AuditActionType;
  detail: string;
  fullName: string;
}

export const columns: GridColDef<QBSActivityLogListItem>[] = [
  {
    field: 'actionTime',
    headerName: 'Time',
    width: 140,
    renderCell: ({ row }) => {
      return <Text variant='inherit'>{formatDateTime(row.actionTime)}</Text>;
    },
  },
  {
    field: 'action',
    headerName: 'Action',
    width: 140,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text variant='inherit'>{getAuditActionTypeText(row.action)}</Text>;
    },
  },
  {
    field: 'detail',
    headerName: 'Description',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        <EllipsisText maxLines={2} variant='inherit'>
          {row.detail}
        </EllipsisText>
      );
    },
  },
  {
    field: 'fullName',
    headerName: 'User',
    width: 240,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text variant='inherit'>{row.fullName}</Text>;
    },
  },
];
